<plugins-text-input
  [formControl]="selectedValuesControl"
  [inputId]="inputId"
  [errorId]="errorId"
  [color]="baseColor"
  [role]="'combobox'"
  [placeholder]="placeholder()"
  [inputClass]="inputClass"
  [inputStyle]="inputStyle"
  [ariaLabel]="ariaLabel"
  [ariaLabelledBy]="ariaLabelledBy"
  [ariaControls]="multiSelectId"
  (click)="showOptions()"
  (keyPressed)="onKeydown($event)"
  cdkOverlayOrigin
  #originOverlay="cdkOverlayOrigin"
  pluginsFocusOutside
  #focusOutside="pluginsFocusOutside"
/>

<icon-chevron class="select-icon" />

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="originOverlay"
  [cdkConnectedOverlayOpen]="(focusOutside.focused$ | async) ?? false"
  [cdkConnectedOverlayFlexibleDimensions]="cdk.flexibleDimensions"
  [cdkConnectedOverlayViewportMargin]="cdk.viewportMargin"
>
  <ul
    [attr.id]="multiSelectId"
    [style]="{
      '--max-height': OPTIONS_MAX_HEIGHT + 'px',
      width: optionsWidth$ | async,
    }"
    [formControl]="control"
    cdkListbox
    [cdkListboxDisabled]="control.disabled"
    [cdkListboxMultiple]="true"
    pluginsFocusContainer
    [focusOutsideDirectiveRef]="focusOutside"
  >
    @for (
      option of options();
      track trackByOption()(index, option);
      let index = $index
    ) {
      @let optionDisabled = isMaxSelected() && !isSelected(option);
      <li [cdkOption]="option" [cdkOptionDisabled]="optionDisabled">
        <span class="selected-option-icon">
          <icon-check [color]="baseColor" />
        </span>
        <ng-container
          [ngTemplateOutlet]="optionTemplateRef() || defaultOption"
          [ngTemplateOutletContext]="{
            $implicit: option,
            index: index,
            disabled: optionDisabled,
          }"
        />
      </li>
    }
  </ul>
</ng-template>

<ng-template let-option #defaultOption>
  <span class="default-option">{{ option }}</span>
</ng-template>
